import Grid from '@material-ui/core/Grid';
import { Typography, Paper } from '@material-ui/core';
import React from 'react';

export default function FormSection({ title, children }) {
    return (
        <Grid item xs={12}>
            <Typography variant="subtitle1">{title}</Typography>
            {children && (
                <Paper className="padded colorcard">
                    <Grid container spacing={2}>
                        {children}
                    </Grid>
                </Paper>
            )}
        </Grid>
    );
}
